<template>
  <div>
    <v-btn
      v-if="$route.path!=='/dashboard/member/my-account'"
      fab
      small
      style="position: absolute; top: 25px; left: 15px; z-index: 100;"
      @click="$router.back()"
      color="accent"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <router-view
      :title="title"
      :logo="logo"
      :permissions="permissions"
      :personalModel="personalModel"
      :settings="settings"
      :overduePayments="overduePayments"
      :upcomingPayments="upcomingPayments"
      :generalAlerts="generalAlerts"
      :properties="properties"
      :payments="payments"
      :allUsers="allUsers"
      :rentals="rentals"
      :propList="propList"

      @refresh-alerts="$emit('refresh-alerts')"
      @refresh-rentals="$emit('refresh-rentals')"
      @refresh-prop-list="$emit('refresh-prop-list')"
      @refresh-payments="$emit('refresh-payments')"
      @allUsers="allUsers=$event"
      @success="$emit('success', $event)"
      @error="$emit('error', $event)"
      @background="$emit('background', $event)"
      @loading="loading=$emit('loading', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'Member',

  props: {
    title: {
      type: String,
      required: true,
    },

    logo: {
      type: String,
      required: false,
    },

    permissions: {
      type: Number,
      required: true,
      default: 0,
    },

    userInfo: {
      type: Object,
      required: true,
    },

    properties: {
      type: Array,
      required: true,
      default: [],
    },

    alerts: {
      type: Object,
      required: true,
    },

    rentals: {
      type: Array,
      required: true,
    },

    propList: {
      type: Array,
      required: true,
    },

    payments: {
      type: Array,
      required: true,
    }
  },

  watch: {
    userInfo(val) {
      this.settings = val.settings ? val.settings : {
        email_yearly_newsletter: null,
        email_official_mbr_notices: null,
        email_paperless_billing: null,
        phone_listed: null,
      };
      this.personalModel = val.info ? val.info : {};
    },

    alerts(val) {
      this.upcomingPayments = val.upcomingPayments ? val.upcomingPayments : {};
      this.overduePayments = val.overduePayments ? val.overduePayments : {};
      this.generalAlerts = val.generalAlerts ? val.generalAlerts : {};
    }
  },

  data: () => ({
    personalModel: {},
    settings: {
      email_yearly_newsletter: null,
      email_official_mbr_notices: null,
      email_paperless_billing: null,
      phone_listed: null,
    },
    overduePayments: [],
    upcomingPayments: [],
    generalAlerts: [],
    allUsers: [],
    connectedUsersDict: [],
    propertiesDict: [],
    complete: 0,
  }),

  methods: {

  },

  mounted() {
    this.$emit('refresh-userinfo');
    this.$emit('refresh-properties');
    this.$emit('refresh-alerts');
  },
};
</script>
